<template>
    <form method="post" @submit.prevent="submitForm">
        <input type="hidden" name="PurchaseOrderId" v-model="PurchaseOrderId"/>
        <purchase-order-edit-item-list ref="poObject" :purchase-order-id="PurchaseOrderId" :new-items="newItems"></purchase-order-edit-item-list>
        <div class="text-center">
            <input type="submit" class="btn btn-success btn-lg w-50" value="submit"/>
        </div>
    </form>
</template>
<script>
    import PurchaseOrderEditItemList from './PurchaseOrderEditItemList.vue'
    export default {
        name : 'purchase-order-edit-form',
        props: ['newItems', 'PurchaseOrderId'],
        components: {
            'purchase-order-edit-item-list' : PurchaseOrderEditItemList
        },
        data(){
            return {
                formData : {
                    data : null
                },
                URLpurchaseOrderUpdateItem: 'purchase-order/items/store',

            }
        },
        methods:{
            submitForm: function(){
                this.formData.data = this.$refs.poObject.itemrows
               

                var unique = this.checkUniqueItems(this.$refs.poObject.itemrows, 'ItemId')
                this.$refs.poObject.itemrows = unique;

                // show message if duplicated items
                this.formData.data.map(v => v.ItemId).sort().sort((a, b) => {
                    if (a === b) alert("We have removed duplicated items")
                })
                this.formData.data = this.$refs.poObject.itemrows;
                this.formData['PurchaseOrderId'] =  this.PurchaseOrderId
                axios.post(this.URLpurchaseOrderUpdateItem, this.formData)
                    .then(response => {
                        if(response.data.success != 1){

                        } else {
                            Swal.fire({
                                title: 'Submitted Successfully',
                                icon: 'success',
                            })
                            this.$refs.poObject.callItemsFromApi(this.PurchaseOrderId)
                        }

                    }).
                catch(error => {
                    this.errored = true
                })
                    .finally(() => this.loading = false)
            },

            checkUniqueItems: function(arr, key){
                var uniqueItems = [...new Map(arr.map(item => [item[key], item])).values()]
                return uniqueItems;
            }
        }
    }
</script>
